import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

const Textarea = ({ className, innerRef, isInvalid, ...rest }) => (
  <textarea
    className={classnames('form-control', { 'border-red': isInvalid }, className)}
    ref={innerRef}
    data-testid="Textarea"
    {...rest}
  />
);

Textarea.propTypes = {
  className: PropTypes.string,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),
  isInvalid: PropTypes.bool,
};

Textarea.defaultProps = {
  className: null,
  innerRef: null,
  isInvalid: false,
};

export default Textarea;
